common:
  save: Sauvegarder
animations:
  stage-transitions:
    title: Désactiver les transitions de scène
  use-page-specific-transitions:
    description: >-
      Certaines pages auront leurs propres transitions, ceci remplacera les transitions de scène.
    title: Utiliser les transitions spécifiques à chaque page
dialogs:
  onboarding:
    title: Bienvenue dans AIRI!
    description: Configurez votre premier fournisseur d’IA pour commencer.
    selectProvider: Choisissez un fournisseur d'IA.
    configureProvider: Configurer {provider}
    apiKey: Clé API
    apiKeyHelp: Obtenez votre clé API {provider} et collez-la ici
    baseUrl: URL de base
    baseUrlHelp: URL de l'endpoint API (utilisez la valeur par défaut si vous n’êtes pas sûr)
    accountId: ID du compte
    validationSuccess: Configuration validation success
    validationFailed: La validation de la configuration a échouée.
    validationError: 'Erreur de validation: {error}'
    skipForNow: Passer pour l'instant
    saveAndContinue: Sauvegarder et Continuer
    next: Suivant
    retry: Retry
    start: Commençons !
    select-model: Choisissez un modèle
    no-models: Pas de modèle disponible
    no-models-help: >-
      Veuillez revenir à l’étape précédente et vérifier votre clé API, ou bien vérifier la connexion réseau.
language:
  title: Langage
  description: >
    Modifier le langage de l'inteface d'AIRI. Cela n'affectera pas le langage des réponses du personnage.
controls-island:
  icon-size:
    title: Controls Island Icon Size
    description: Adjust the size of the controls island icons
    auto: Auto (responsive)
    large: Large (default)
    small: Small
live2d:
  change-model:
    from-file: Charger depuis un Fichier
    from-file-select: Sélectionner
    from-url: Charger depuis une URL
    from-url-confirm: Charger
    from-url-placeholder: Entrer l'URL d'un modèle Live2D
    title: Changer de Modèle
  edit-motion-map:
    title: Modifier la carte des mouvements
  map-motions:
    play: Jouer le mouvement
    title: Cartographier les mouvements
  title: Paramètres Live2D
  scale-and-position:
    title: Échelle et position
    scale: Échelle
    x: X
    'y': 'Y'
  switch-to-vrm:
    title: Passer à l’avatar 3D ?
    change-to-vrm: Cliquez ici pour passer aux paramètres de l’avatar 3D (VRM)
  theme-color-from-model:
    title: Extraire les couleurs du modèle
    button-extract:
      title: Extraire
  focus:
    title: Désactiver le suivi du modèle par la souris
    button-disable:
      title: Désactiver
microphone: Microphone
models: Modèle
pages:
  card:
    activate: Activer
    active: Actif
    active_badge: Actuellement actif
    cancel: Cancel action
    save: Save changes
    card_not_found: Carte non trouvée
    character: Personnage
    close: Fermer
    consciousness:
      model: Conscience / Modèle
    created_by: créé par
    creator_notes: Notes du créateur
    delete: Supprimer
    delete_card: Supprimer la carte
    delete_confirmation: Êtes-vous sûr de vouloir supprimer cette carte ?
    description: Utiliser les préréglages des cartes d'AIRI
    description_label: Description
    drop_here: Déposer pour téléverser
    create_card: Créer une nouvelle carte
    edit_card: Edit Card
    creation:
      identity: Identité
      name: Nom
      nickname: Surnom
      description: Description
      behavior: Comportement
      greetings: Salutations (une par ligne)
      settings: Paramètres
      version: Version
      create: Créer
      defaults:
        name: Nom
        personality: Vous êtes une personne normale, curieuse de tout.
        scenario: Vous vous êtes récemment réveillé et avez tout oublié de votre vie passée.
        systemprompt: Vous recevrez des messages et y répondrez comme un humain.
        posthistoryinstructions: N’oubliez pas d’imiter un humain.
      fields_info:
        subtitle: >-
          Vous pouvez ici ajouter des détails sur le personnage que vous créez, expliquer son histoire et son contexte, et comment vos interactions devraient être répondues.
        name: Le nom officiel du personnage.
        nickname: Vous pouvez également donner un surnom qui sera utilisé en priorité.
        description: Description du personnage.
        notes: Si vous souhaitez ajouter des notes personnelles.
        personality: >-
          Décrivez ici la personnalité de votre personnage. Timide ? Curieux ? Autre chose ?
        scenario: Quel est l’environnement ? Quelle est la situation actuelle ?
        greetings_field: Salutations
        greetings: Comment votre personnage devrait dire « bonjour » ?
        systemprompt: Expliquez ici à l’IA comment elle doit répondre lorsqu’on l’interroge.
        posthistoryinstructions: Placez ici tout ce que l’IA doit lire après l’historique des messages.
        version: >-
          Version de la carte, vous devez l’incrémenter si vous apportez des modifications par rapport à une carte précédente.
      errors:
        name: Le nom doit être valide ou non vide.
        version: 'Erreur : numéro de version invalide !'
        description: 'Erreur : vous devez fournir une description pour cette carte.'
        personality: 'Erreur : une personnalité doit être fournie pour ce personnage.'
        scenario: 'Erreur : un scénario est requis.'
        systemprompt: 'Erreur : veuillez fournir un prompt système.'
        posthistoryinstructions: 'Erreur : le prompt post-historique est requis.'
    modules: Modules
    name_asc: Nom (A-Z)
    name_desc: Nom (Z-A)
    no_cards: Aucune carte pour le moment. Cliquez sur le bouton ci-dessus pour en téléverser une !
    no_results: Aucune carte correspondante trouvée
    personality: Personnalité
    posthistoryinstructions: Instructions post-historique
    recent: Récemment ajouté
    scenario: Scénario
    search: Rechercher des cartes...
    sort_by: Trier par
    speech:
      model: Parole / Modèle
      voice: Parole / Voix
    systemprompt: Prompt système
    title: Carte AIRI
    try_different_search: Essayez un autre terme de recherche
    upload: Téléverser
    upload_desc: Cliquez ou glissez un fichier pour téléverser
  memory:
    description: Endroit où les souvenirs sont stockés et organisés
    title: Mémoire
  data:
    title: Data
    description: Manage stored AIRI data, exports, and resets
    sections:
      chats:
        title: Chat sessions
        description: Export or import saved chat sessions.
        export: Export chats
        import: Import chats
        delete: Delete all chat sessions
      models:
        title: Models
        description: Remove imported Live2D/VRM models.
        delete: Delete all models
      modules:
        title: Modules
        description: Reset module preferences and credentials.
        reset: Reset module settings
      providers:
        title: Providers
        description: Reset all provider settings and credentials.
        reset: Reset provider settings
      danger:
        title: Danger zone
        description: Irreversible actions. Export what you need before continuing.
      all:
        title: Delete all data
        description: Wipe every local setting, provider config, and model.
        delete: Delete all data
      desktop:
        title: Reset desktop settings & states
        description: Clear AIRI desktop settings and runtime state.
        reset: Reset desktop data
    confirmations:
      tooltip: Are you sure?
      'yes': 'Yes'
    status:
      exported: Chat sessions exported.
      imported: Chat sessions imported.
      import_error: Failed to import chat sessions. Please check the file format.
      chats_deleted: Chat sessions deleted.
      models_deleted: Models deleted.
      modules_reset: Module settings reset.
      providers_reset: Provider settings reset.
      all_deleted: All local data deleted.
      desktop_reset: Desktop data reset.
  models:
    description: Live2D, VRM, etc.
    title: Modèles
    sections:
      section:
        live2d:
          title: Live2D
          description: Configurer les modèles et paramètres Live2D
        vrm:
          title: VRM
          description: Configurer les modèles et paramètres 3D VRM
        scene: Scène
  modules:
    beat_sync:
      description: Vibe with beats from the audio source
      title: Beat Sync
      sections:
        audio_source:
          actions:
            start_screen_capture: Start screen capture
            stop: Stop
          description: Select an audio source to detect beats from.
          title: Audio source
        beat_visualizer:
          title: Beat visualizer
        parameters:
          advanced_parameters: Advanced Parameters
          description: Tweak the beat detection parameters.
          title: Parameters
          parameters:
            adaptive_threshold:
              description: >-
                Whether to apply adaptive thresholds based on signal variance over time.
              label: Adaptive threshold
            buffer_duration:
              description: Duration of the internal analysis buffer.
              label: Buffer duration
            envelope_filter_frequency:
              description: >-
                Frequency for the envelope filter applied to smooth energy changes.
              label: Envelope filter frequency
            highpass_filter_frequency:
              description: >-
                Frequency for the highpass filter applied to reduce low frequencies like sub-bass noises.
              label: Highpass filter frequency
            lowpass_filter_frequency:
              description: >-
                Frequency for the lowpass filter applied to reduce high frequencies like vocals.
              label: Lowpass filter frequency
            min_beat_interval:
              description: Maximum BPM or minimum interval between detected beats.
              label: Max BPM / Min beat interval
            sensitivity:
              label: Sensitivity
            spectral_flux:
              description: Whether to enable spectral flux-based onset detection.
              label: Spectral flux
            warmup:
              description: Whether to warm up before detecting beats for better accuracy.
              label: Warmup
    consciousness:
      description: Personnalité, modèle désiré, etc.
      sections:
        section:
          provider-model-selection:
            collapse: Réduire
            custom_model_placeholder: Entrez le nom du modèle personnalisé...
            description: Sélectionnez le fournisseur LLM approprié pour la conscience
            error: Erreur lors du chargement des modèles
            health_check_failed: Health check failed
            no_providers_configured_title: No Providers Configured
            no_providers_configured_description: Click here to set up your LLM providers
            expand: Développer
            loading: Chargement des modèles disponibles...
            manual_model_name: Nom du modèle
            manual_model_placeholder: Entrez le nom du modèle à utiliser avec ce fournisseur
            no_models: Aucun modèle disponible
            no_models_description: Aucun modèle trouvé pour ce fournisseur
            no_search_results: Aucun modèle correspondant
            no_search_results_description: Aucun modèle ne correspond à '{query}'. Essayez un autre terme.
            not_supported: Liste des modèles non supportée
            not_supported_description: Ce fournisseur ne supporte pas la fonctionnalité de liste des modèles
            search_placeholder: Rechercher des modèles...
            search_results: '{count} modèles trouvés sur {total}'
            show_less: Afficher moins
            show_more: Afficher plus
            subtitle: Sélectionnez un modèle du fournisseur
            title: Modèle
      title: Conscience
    description: Synthèse, vision, parole, jeux, etc.
    gaming-factorio:
      description: Jouer à Factorio !
      title: Factorio
      enable: Activer l'intégration Factorio
      enable-description: Autoriser AIRI à interagir avec le jeu Factorio
      server-address: Adresse du serveur
      server-address-description: L'adresse IP ou le nom d'hôte du serveur Factorio
      server-address-placeholder: Entrez l'adresse du serveur (ex. localhost ou 192.168.1.100)
      server-port: Port du serveur
      server-port-description: Le numéro de port du serveur Factorio (par défaut 34197)
      username: Nom d'utilisateur
      username-description: Votre nom d'utilisateur sur le serveur Factorio
      username-placeholder: Entrez votre nom d'utilisateur Factorio
      configured: Factorio est correctement configuré !
    gaming-minecraft:
      description: Jouer à Minecraft !
      title: Minecraft
      enable: Activer l'intégration Minecraft
      enable-description: Autoriser AIRI à interagir avec le jeu Minecraft
      server-address: Adresse du serveur
      server-address-description: L'adresse IP ou le nom d'hôte du serveur Minecraft
      server-address-placeholder: Entrez l'adresse du serveur (ex. localhost ou play.exemple.com)
      server-port: Port du serveur
      server-port-description: Le numéro de port du serveur Minecraft (par défaut 25565)
      username: Nom d'utilisateur
      username-description: Votre nom d'utilisateur sur le serveur Minecraft
      username-placeholder: Entrez votre nom d'utilisateur Minecraft
      configured: Minecraft est correctement configuré !
    hearing:
      description: Configurer la reconnaissance vocale
      title: Audition
      sections:
        section:
          provider-selection:
            description: Select the suitable speech recognition provider
    memory-long-term:
      description: Paramètres et gestion de la mémoire à long terme
      title: Mémoire à long terme
    memory-short-term:
      description: Paramètres et gestion de la mémoire à court terme
      title: Mémoire à court terme
    messaging-discord:
      description: Chat et chat vocal via Discord
      title: Discord
      enable: Activer l'intégration Discord
      enable-description: Autoriser AIRI à interagir via Discord
      token: Jeton du bot
      token-description: Votre jeton de bot Discord
      token-placeholder: Entrez votre jeton de bot Discord
      configured: Discord est correctement configuré !
    speech:
      description: Synthèse vocale
      sections:
        section:
          playground:
            buttons:
              stop:
                label: Arrêter
            select-voice:
              required: Veuillez sélectionner une voix
          provider-voice-selection:
            custom_model_placeholder: Entrez le nom du modèle personnalisé...
            custom_voice_placeholder: Entrez l’ID de la voix personnalisée...
            description: Sélectionnez le fournisseur de synthèse vocale approprié
            no_models: Aucun modèle disponible
            no_models_description: Aucun modèle trouvé pour ce fournisseur
            no_voices: Aucune voix disponible
            no_voices_description: Aucune voix trouvée pour ce fournisseur
            no_voices_hint: Vous pouvez entrer un nom de voix personnalisé ci-dessous.
            pause: Pause
            play_sample: Jouer l’exemple
            search_models_placeholder: Rechercher des modèles...
            search_models_results: '{count} modèles trouvés sur {total}'
            search_voices_placeholder: Rechercher des voix...
            search_voices_results: '{count} voix trouvées sur {total}'
            unsupported_voice_warning_title: No supported voices
            unsupported_voice_warning_content: >-
              Try a different model or provider. We are working on supporting all the voice for this model as quickly as possible. If you need it urgently, please let us know on GitHub at https://github.com/moeru-ai/airi/issues.
            show_less: Afficher moins
            show_more: Afficher plus
            title: Fournisseur
          voice-settings:
            input-ssml:
              placeholder: Entrez le texte SSML...
            use-ssml:
              description: Activez pour saisir du SSML brut au lieu de texte simple
              label: Utiliser SSML personnalisé
      title: Parole
    title: Modules
    vision:
      description: Vision
      title: Vision
    x:
      description: Navigation et utilisation X / Twitter
      title: X / Twitter
      enable: Activer l'intégration X / Twitter
      enable-description: Autoriser AIRI à interagir avec X / Twitter
      api-key: Clé API
      api-key-description: Votre clé API X / Twitter
      api-key-placeholder: Entrez votre clé API X / Twitter
      api-secret: Secret API
      api-secret-description: Votre secret API X / Twitter
      api-secret-placeholder: Entrez votre secret API X / Twitter
      access-token: Jeton d'accès
      access-token-description: Votre jeton d'accès X / Twitter
      access-token-placeholder: Entrez votre jeton d'accès X / Twitter
      access-token-secret: Secret du jeton d'accès
      access-token-secret-description: Votre secret de jeton d'accès X / Twitter
      access-token-secret-placeholder: Entrez votre secret de jeton d'accès X / Twitter
      configured: X / Twitter est correctement configuré !
    mcp-server:
      description: Connecter et gérer le serveur MCP et ses outils
      title: Serveur MCP
  providers:
    explained:
      chat: Fournisseurs de modèles de génération de texte, par ex. OpenRouter, OpenAI, Ollama.
      Speech: Fournisseurs de modèles de synthèse vocale, par ex. ElevenLabs, Azure Speech.
      Transcription: >-
        Fournisseurs de modèles de transcription (speech-to-text), par ex. Whisper.cpp, OpenAI, Azure Speech
    helpinfo:
      title: Première fois ici ?
      description: >
        AIRI nécessite qu’au moins un fournisseur {chat} soit configuré pour penser et se comporter correctement. On peut le considérer comme le cerveau des personnages vivant dans le système AIRI.
    catalog:
      edit:
        config-id-not-found: Provider configuration not found.
        definition-id-not-found: Provider definition not found.
        actions:
          more-options: More options
          delete: Delete
        validation:
          failed:
            title: Please check your provider settings, validation failed.
            description: You can still save the current configuration if you want to proceed.
            action: Save anyway
        config:
          common:
            fields:
              field:
                api-key:
                  label: API Key
                  description: API Key used to authorize requests to this provider
                  placeholder: sk-...
                base-url:
                  label: Base URL
                  description: >-
                    The base url used to connect to remote service. Often looks like http://localhost:11434/v1 or https://example.com/v1.
                  placeholder: Base url...
                headers:
                  label: Custom HTTP Headers
                  description: Add custom HTTP headers
                  key:
                    placeholder: Key
                  value:
                    placeholder: Value
        validators:
          actions:
            validate: Validate
          empty: No validation steps available.
          openai-compatible:
            check-config:
              title: Configuration
            check-connectivity:
              title: Connectivity
            check-supports-model-listing:
              title: List Models
            check-supports-chat-completion:
              title: Chat Completion
          status:
            validating: Validating...
            valid: Passed
            invalid: Errored
          title: Checks
        providers:
          provider:
            ollama:
              troubleshooting:
                validators:
                  openai-compatible-check-connectivity:
                    label: Extra configuration needed for Ollama
                    content: >-
                      Sorry to hear that Connectivity check failed for Ollama. Don't worry, for Ollama instances, extra configuration is needed for making it pass for Ollama. You need to set <code>OLLAMA_HOST</code> explicitly when start the Ollama application or Ollama CLI server, for detailed information, check <a href="https://airi.moeru.ai/docs/en/docs/manual/integrations/providers/chat/ollama">Ollama integration guide</a>.
    common:
      continueAnyway: Continuer quand même
      fields:
        field:
          api-key:
            label: Saisie de clé API
      section:
        advanced:
          fields:
            field:
              headers:
                description: Ajouter des en-têtes HTTP personnalisés
                key:
                  placeholder: Clé
                label: En-têtes HTTP
                value:
                  placeholder: Valeur
          title: Avancé
        basic:
          description: Paramètres essentiels
          title: Basique
        voice:
          title: Paramètres de la voix
    description: LLMs, fournisseurs vocaux, etc.
    provider:
      app-local-audio-transcription:
        title: Application (Locale)
        description: https://github.com/moeru-ai/xsai-transformers
      app-local-audio-speech:
        title: Application (Locale)
        description: https://github.com/moeru-ai/xsai-transformers
      browser-local-audio-transcription:
        title: Navigateur (Local)
        description: https://github.com/moeru-ai/xsai-transformers
      browser-local-audio-speech:
        title: Navigateur (Local)
        description: https://github.com/moeru-ai/xsai-transformers
      alibaba-cloud-model-studio:
        description: bailian.console.aliyun.com
        title: Studio de modèles Alibaba Cloud
      anthropic:
        description: anthropic.com
        title: Anthropic | Claude
        helpinfo:
          title: Avant de commencer
          description:
            part1: >-
              Bien qu’Anthropic ait récemment annoncé un support bêta pour la compatibilité SDK OpenAI
            part2: (vous pouvez en lire plus ici)
            part3: en raison de détails d’implémentation
            part4: >-
              des restrictions non alignées avec le SDK OpenAI, il n’est actuellement pas possible d’utiliser ce fournisseur dans le navigateur.
            part5: >-
              Si vous devez utiliser ce fournisseur, vous aurez besoin d’un proxy backend dédié comme une fonction serverless
            part6: ou des services contournant le CORS pour éviter les restrictions CORS.
      cloudflare-workers-ai:
        description: cloudflare.com
        fields:
          field:
            account-id:
              description: ID de compte Cloudflare
              label: ID de compte
              placeholder: Votre ID de compte Cloudflare
            api-key:
              placeholder: Saisir la clé API Cloudflare
        title: Cloudflare Workers AI
      common:
        status:
          validating: Validation en cours
          valid: La configuration semble valide.
        fields:
          field:
            pitch:
              description: 'Ajuster la hauteur de la voix synthétisée (ex : plus aiguë ou plus grave)'
              label: Hauteur
            speed:
              description: Ajuster la vitesse de la parole
              label: Vitesse
            volume:
              description: Ajuster le volume de la parole
              label: Volume
      deepgram-tts:
        description: deepgram.com
        title: Deepgram
      deepseek:
        description: deepseek.com
        title: DeepSeek
      elevenlabs:
        description: elevenlabs.io
        fields:
          field:
            simularity-boost:
              description: Adhérence à la voix originale
              label: Boost de similarité
            speaker-boost:
              description: Améliorer la similarité du locuteur
              label: Boost du locuteur
            speed:
              description: Vitesse de génération de la parole
              label: Vitesse
            stability:
              description: Stabilité et aléatoire de la voix
              label: Stabilité
            style:
              description: Exagération du style de la voix
              label: Style
        playground:
          buttons:
            button:
              test-voice:
                generating: Génération...
                label: Tester la voix
          fields:
            field:
              input:
                placeholder: Entrez le texte pour tester la voix...
              language:
                description: Sélectionnez la langue de la voix
                label: Langue
              voice:
                description: Sélectionnez la voix préférée
                label: Voix
          title: Terrain de test de la voix
          validation:
            error-missing-api-key: Veuillez entrer une clé API pour tester la voix.
        title: ElevenLabs
      fireworks:
        description: fireworks.ai
        title: Fireworks.ai
      microsoft-speech:
        description: speech.microsoft.com
        fields:
          field:
            region:
              description: Speech Service region
              label: Région
        title: Microsoft / Azure Speech
      index-tts-vllm:
        description: https://index-tts.github.io/
        title: Bilibili / IndexTTS
      azure-ai-foundry:
        description: Azure AI Foundry
        title: Azure AI Foundry
      mistral:
        description: mistral.ai
        title: Mistral
      moonshot:
        description: moonshot.ai
        title: Moonshot AI
      modelscope:
        description: modelscope.cn
        title: ModelScope
      novita:
        description: novita.ai
        title: Novita
      ollama:
        description: ollama.ai
        title: Ollama
      openai:
        description: openai.com
        title: OpenAI
      openai-compatible:
        description: OpenAI Compatible
        title: OpenAI Compatible
      openrouter:
        description: openrouter.ai
        title: OpenRouter
      perplexity:
        description: perplexity.ai
        title: Perplexity
      player2:
        description: player2.game
        title: Player2
      together:
        description: together.ai
        title: Together.ai
      google-generative-ai:
        description: gemini.google.com
        title: Google Gemini
      groq:
        description: groq.com
        title: Groq
      featherless:
        description: featherless.ai
        title: Featherless AI
      lm-studio:
        description: lmstudio.ai
        title: LM Studio
      vllm:
        description: vllm.ai
        title: vLLM
      volcengine:
        description: volcengine.com
        fields:
          field:
            appId:
              description: ID de l’application du projet, que vous pouvez obtenir dans la Console
              label: ID de l’application
        title: Volcano Engine
      xai:
        description: x.ai
        title: xAI
      302-ai:
        description: 302.AI
        title: 302.AI
      comet-api:
        description: CometAPI.com
        title: Comet API
      cerebras:
        description: cerebras.ai
        title: Cerebras
      aliyun-nls:
        description: Aliyun NLS
        title: Aliyun NLS
      browser-web-speech-api:
        description: Browser-native STT (requires Chrome/Edge/Safari)
        title: Web Speech API
      transcriptions:
        playground:
          title: Terrain de test de transcription
    title: Fournisseurs
  connection:
    description: Configure WebSocket server connection
    title: Connection
    websocket-url:
      description: Full address of the WebSocket server (e.g., ws://localhost:6121/ws)
      label: WebSocket Server Address
      placeholder: ws://localhost:6121/ws
  scene:
    description: Configurer l’environnement où vit le personnage
    title: Scène
  system:
    color-scheme:
      description: Modifier le schéma de couleurs de la scène.
      title: Schéma de couleurs
    developer:
      description: Quelques options pour développeurs.
      title: Développeurs
    general:
      description: Thème sombre, langues, etc.
      title: Général
    description: Personnalisez votre scène !
    sections:
      section:
        custom-color:
          fields:
            field:
              primary-color:
                label: Couleur principale
                rgb-on:
                  title: Je veux que ce soit dynamique !
          title: Schéma de couleurs
        developer:
          title: Développeur
          sections:
            section:
              performance-visualizer:
                title: Performance Visualizer
                description: Toggle FPS/long task/memory overlay
              markdown-stress:
                title: Markdown Stress
                description: Stress markdown parsing and rendering with heavy chat payloads
              use-magic-keys:
                title: useMagicKeys
                description: Test shortcuts
        theme-presets:
          presets:
            default:
              colors:
                color-1: AIRI Green
              description: The default greenish theme color, brought by AIRI to you!
              title: Default Color
            morandi:
              colors:
                color-1: Taupe
                color-2: Beige
                color-3: Ash Grey
                color-4: Light Taupe
                color-5: Ivory
                color-6: Olive Grey
                color-7: Sand
                color-8: Warm Grey
              description: Soft, muted tones inspired by Giorgio Morandi's paintings
              title: Morandi Colors
            monet:
              colors:
                color-1: Sky Blue
                color-2: Mist
                color-3: Sand
                color-4: Moss Green
                color-5: Water Lily
                color-6: Wheat
                color-7: Slate Blue
                color-8: Sage
              description: Impressionist palette inspired by Claude Monet's works
              title: Monet Colors
            japanese:
              colors:
                color-1: Tan
                color-2: Warm Taupe
                color-3: Umber
                color-4: Coffee
                color-5: Bronze
                color-6: Gold
                color-7: Mustard
                color-8: Amber
              description: Traditional Japanese color palette
              title: Japanese Colors
            nordic:
              colors:
                color-1: Nordic Blue
                color-2: Ice
                color-3: Fjord
                color-4: Steel
                color-5: Glacier
                color-6: Slate
                color-7: Cloud
                color-8: Stone
              description: Scandinavian minimalist color scheme
              title: Nordic Colors
            chinese:
              colors:
                color-1: Rosy Dawn
                color-2: Chinese Red
                color-3: Smoky Brown
                color-4: Bamboo Green
                color-5: Dark Purple
                color-6: Golden Yellow
                color-7: Azure Blue
                color-8: Ochre
              description: >-
                Traditional Chinese colors, derived from ancient textiles, porcelain and paintings
              title: Chinese Traditional Colors
          title: Préréglages de couleurs
    title: Apparence
  page:
    developers:
      open-devtools:
        title: Open Developer Tools
        button: Open
sections:
  section:
    general:
      title: Général
theme:
  title: Thème
  description: |
    Changez le thème de base d’AIRI, mode clair ou mode sombre.
title: Paramètres
voices: Voix
vrm:
  change-model:
    from-file: Charger depuis un fichier
    from-file-select: Sélectionner
    from-url: Charger depuis une URL
    from-url-confirm: Charger
    from-url-placeholder: Entrez l’URL du modèle VRM
    title: Changer de modèle
  title: Paramètres VRM
  scale-and-position:
    model-info-title: Informations sur la taille du modèle
    model-info-x: Largeur (X)
    model-info-y: Hauteur (Y)
    model-info-z: Profondeur (Z)
    tips: |
      Modifiez la position initiale du modèle VRM.
      Les axes de coordonnées sont visualisés.
    scale: Échelle
    x: Décalage X
    'y': Décalage Y
    z: Décalage Z
    fov: FOV (degré)
    rotation-y: Rotation (axe Y)
    camera-distance: Distance de la caméra
    eye-tracking-mode:
      title: Regarder vers
      options:
        option:
          camera: Caméra
          mouse: Souris
          disabled: Désactivé
  switch-to-vrm:
    title: Passer à l’avatar Live2D ?
    change-to-vrm: Cliquez ici pour passer aux paramètres de l’avatar Live2D
  theme-color-from-model:
    button-extract:
      title: Extraire
  skybox:
    skybox-intensity: Intensité de la SkyBox
    skybox-specular-mix: Mélange spéculaire
wip:
  title: Work in Progress
  description: >-
    This feature is currently under development and not yet publicly available. Check back in future updates for this functionality.
